export default __webpack_public_path__ + "static/media/Abhishek1.49da57ea.jpg";